const prefix = 'BEZIRKE/'

export const REQUEST = prefix + 'REQUEST'
export const RECEIVE = prefix + 'RECEIVE'
export const SELECT = prefix + 'SELECT'


// WEBPACK FOOTER //
// ./src/types/bezirke.js